import { smStyle } from '@/components/Adapter'
import styled from 'styled-components'

export const FundraisingChartStyled = styled.div`
  width: 100%;
  height: 330px;
  margin-top: 24px;

  .fundraising-chart {
    width: 100%;
    height: 330px;
  }

  ${smStyle} {
    height: 410px;

    .fundraising-chart {
      height: 410px;
    }
  }
`
